<template>
    <div
        v-loading="loading"
        class="online-event-form"
    >
        <el-form
            ref="form"
            :rules="rules"
            :model="form"
            label-position="top"
        >
            <el-form-item
                prop="title"
                label="Название"
            >
                <el-input v-model="form.title" />
            </el-form-item>
            <el-form-item
                label="Дата проведения"
                prop="dates"
            >
                <el-date-picker
                    v-model="form.dates"
                    :format="datepickerDateFormat"
                    style="width: 100%;"
                    type="daterange"
                    range-separator=""
                    start-placeholder="Начало"
                    end-placeholder="Конец"
                />
            </el-form-item>
            <el-form-item
                prop="prepay"
                label="Стоимость участия"
            >
                <el-input v-model.number="form.prepay" />
            </el-form-item>
            <el-switch
                v-model="form.registration_suspended"
                active-color="#ff4949"
                inactive-color="#13ce66"
                active-text="Неактивен"
                inactive-text="Активен"
            />
        </el-form>
        <el-row>
            <el-button
                type="primary"
                @click="trySend"
            >
                {{ buttonText }}
            </el-button>
        </el-row>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
    name: 'OnlineEventForm',
    props: {
        eventId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            rules: {
                title: [
                    { required: true, message: 'Введите название фестиваля' }
                ],
                prepay: [
                    { required: true, message: 'Укажите стоимость участия' },
                    { type: 'number', message: 'Укажите стоимость' },
                    {
                        validator: (rule, value, callback) => {
                            if (value === 0) {
                                return callback(new Error('Стоимость не может быть равна нулю'));
                            }
                            callback();
                        }
                    }
                ],
                dates: [
                    { required: true, message: 'Укажие даты проведения' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || !value[0] || !value[1]) {
                                return callback(new Error('Укажие даты проведения'));
                            }
                            const eventStart = moment(value[0]);
                            const eventEnd = moment(value[1]);
                            if (eventStart.diff(eventEnd) >= 0) {
                                return callback(
                                    new Error('Дата начала события должна быть раньше даты завершения')
                                );
                            }
                            callback();
                        }
                    }
                ]
            },
            form: {
                title: undefined,
                prepay: undefined,
                registration_suspended: false
            }
        };
    },
    computed: {
        ...mapState('config', [
            'datepickerDateFormat'
        ]),
        ...mapGetters('onlineEvent', [
            'loading',
            'event'
        ]),
        isEditMode() {
            return !!this.eventId;
        },
        buttonText() {
            return this.isEditMode ? 'Сохранить' : 'Создать';
        }
    },
    mounted() {
        if (this.eventId) {
            this.fetchEvent({ eventId: this.eventId })
                .then(() => {
                    let data = this.event;
                    data.dates = [
                        this.event.start_at,
                        this.event.end_at
                    ];
                    data.prepay = Number.parseFloat(this.event.prepay);
                    this.form = { ...data };
                })
                .catch(() => this.$message.error('Ошибка получения данных'));
        }
    },
    methods: {
        ...mapActions('onlineEvent', [
            'fetchEvent',
            'createEvent',
            'updateEvent',
            'deleteEvent'
        ]),
        trySend() {
            this.$refs.form.validate()
                .then(() => {
                    if (this.isEditMode) {
                        return this.updateEvent({ eventId: this.eventId, data: this._mapFormAttributes() })
                            .then(() => {
                                this.$message.success('Событие успешно обновлено');
                                this.$router.push({ name: 'online-event.list' });
                            })
                            .catch(() => this.$message.error('Ошибка создания события'));
                    }

                    this.createEvent({ data: this._mapFormAttributes() })
                        .then(() => {
                            this.$message.success('Событие успешно создано');
                            //this.$router.push({ name: 'online-event.list' });
                        })
                        .catch(() => this.$message.error('Ошибка создания события'));
                })
                .catch(() => this.$message.warning('Проверьте форму'));
        },
        _mapFormAttributes() {
            const start = moment(this.form.dates[0]);
            const end = moment(this.form.dates[1]);
            return {
                ...this.form,
                start_at: start,
                end_at: end
            };
        }
    }
};
</script>

<style lang="scss">
.online-event-form {
  max-width: 510px;
}
</style>
